/* eslint-disable max-lines */
import {
  AfterContentChecked,
  AfterViewInit,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  ViewEncapsulation
} from '@angular/core';
import { LOGIN_DL_VS_ROUTES_REGEX } from '@com-delta-idp/mnx-sitewide-shared-core-smart';
import { ANALYTICS_EVENTS_LOGIN } from '../../data-access/login-modal/constants/analytics-constants';
import {
  PARAMS_TO_IGNORE,
  VIEW_NAME
} from '../../data-access/login-modal/constants/login-constant';
import { IS_STANDALONE_PAGE$ } from '../../data-access/login-modal/facade/facade.service';
import { LoginModalHelperComponent } from './login-modal-helper.component';
@Component({
  selector: 'idp-login-modal',
  templateUrl: './login-modal.component.html',
  styleUrls: ['./login-modal.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoginModalComponent
  extends LoginModalHelperComponent
  implements AfterViewInit, OnChanges, AfterContentChecked, OnInit
{
  @Output() hideModal = new EventEmitter();
  @Output() logOut = new EventEmitter();
  @Input() shouldcallservice!: string;
  @Input() fromApp!: string;
  @Input() displayLoginModal = false;
  @Input() fromStandAlonePage = false;
  @Input() centerPage = false;
  @Input() fromRecognitionPage = false;
  @Input() redirectUrl: string | undefined;
  @Input() checkOutWarmState = false;
  @Input() callbackurl = '';
  @ViewChild('loginModal', { static: false })
  loginModal!: ElementRef;

  advisorBanner = false;
  viewName = VIEW_NAME;
  lastNameField = false;

  bauRefreshURL!: string;
  queryParamKeys!: string[];
  paramsToIgnore!: string[];
  queryParams!: { [key: string]: string };
  queryParamsCheck = false;
  formElement!: ElementRef;
  infoIconClicked = false;

  @ViewChild('loginStandaloneRedirectForm')
  loginStandaloneRedirectForm!: ElementRef<HTMLFormElement>;

  getElementRef() {
    this.getElementRefHelper(this.loginStandaloneRedirectForm);
  }

  getElementRefHelper(element: ElementRef) {
    this.formElement = element;
  }

  getQueryParams() {
    const paramsArr: { [x: string]: string }[] = [];
    const bauUrl = '';
    this.route.queryParams.subscribe((params) => {
      const { queryParams, bauRefreshURL } = params;
      if (queryParams && bauRefreshURL) {
        this.getQueryParamsHelper(
          paramsArr,
          bauUrl,
          queryParams,
          bauRefreshURL
        );
      }
    });
  }

  getQueryParamsHelper(
    paramsArr: { [x: string]: string }[],
    bauUrl: string,
    queryParams: string,
    bauRefreshURL: string
  ) {
    bauUrl = bauRefreshURL;
    this.queryParamsCheck = true;
    const fieldName: string[] = [];
    const encryptedValue: string[] = [];
    const responseSplitted = queryParams.split('|');
    if (responseSplitted.length > 0) {
      responseSplitted.forEach((queryParams: string) => {
        fieldName.push(queryParams.split('=')[0]);
        encryptedValue.push(queryParams.split('=')[1]);
      });
    }
    for (let i = 0; i < fieldName.length; i++) {
      paramsArr.push({
        [fieldName[i]]: encryptedValue[i]
      });
    }
    const returnParams: { [key: string]: string } = Object.assign(
      {},
      ...paramsArr
    );
    if (bauUrl) {
      this.assignQueryParams(returnParams, bauUrl);
    }
  }

  getRefreshURL(refreshURL: string): string {
    const contextRoot = '/home';
    const homePageUrl = '/';
    if (refreshURL && this.getRefreshURLCheck(refreshURL, contextRoot)) {
      return refreshURL;
    }
    return homePageUrl;
  }

  getRefreshURLCheck(refreshURL: string, contextRoot: string) {
    return (
      refreshURL !== '' &&
      refreshURL !== 'null' &&
      refreshURL !== null &&
      refreshURL.indexOf(contextRoot) === -1
    );
  }

  assignQueryParams(queryParams: { [key: string]: string }, bauUrl: string) {
    this.queryParams = queryParams;
    this.queryParamKeys = Object.keys(queryParams);
    this.paramsToIgnore = PARAMS_TO_IGNORE;
    this.bauRefreshURL = this.getRefreshURL(bauUrl);
  }

  ngOnInit(): void {
    if (this.loginHelperUtils.getRefreshURLParams().fromAdmin) {
      this.loginHelperUtils.fromAdmin$.next(true);
    }

    this.fromStandAlonePage = window.location.pathname.match(
      LOGIN_DL_VS_ROUTES_REGEX
    )
      ? true
      : false;
    if (this.fromStandAlonePage) {
      this.setupStandalonePage();
    }
  }

  setupStandalonePage(): void {
    this.facade.standalonePage = true;
    IS_STANDALONE_PAGE$.next(true);
    this.getQueryParams();

    if (this.getCCRLogoutParam()) {
      this.facade.fromCcrPage$.next(true);
    }

    this.nextDisplayViewService.modalContainerFocus();
    const flag = this.getCallServiceFlagStandAlonePage();
    this.callServices(flag);
    this.setLoaderForStandAlone();
  }

  getCCRLogoutParam(): boolean {
    const urlParams = new URLSearchParams(window.location.search);
    const ccrLogoutState = urlParams.get('ccrLogoutState');
    return ccrLogoutState === 'true';
  }

  getCallServiceFlagStandAlonePage(): string {
    return window.location.pathname.includes(VIEW_NAME.PROFILE_PICKER)
      ? 'false'
      : 'true';
  }

  ngAfterViewInit() {
    this.getInnerWidth();
    this.setModalPosition();
    if (this.fromStandAlonePage) {
      this.getElementRef();
      this.nextDisplayViewService.modalContainerFocus();
      this.setStyleForStandalone();
      this.setLoaderForStandAlone();
    }
  }

  callSetModalPosition() {
    if (!this.fromStandAlonePage) {
      this.setModalPosition();
    }
  }

  @HostListener('document:click')
  public onPageClick() {
    this.getInnerWidth();
    this.callSetModalPosition();
  }

  @HostListener('window:resize')
  onResize() {
    this.getInnerWidth();
    this.callSetModalPosition();
  }

  @HostListener('document:keydown', ['$event'])
  handleTabKeyWInModel(event: KeyboardEvent) {
    if (this.fromStandAlonePage) return;
    this.handleTabKey(
      event,
      '#login-modal-wrapper',
      'input,button,select,textarea,a,[tabindex]:not([tabindex="-1"])'
    );
  }

  getInnerWidth() {
    this.innerWidth = window.innerWidth;
  }

  setModalPosition() {
    if (this.loginModal.nativeElement) {
      this.setModalPositionHelper(this.loginModal.nativeElement);
    }
  }

  setStyleForStandalone() {
    this.setStyleForStandaloneHelper(this.loginModal.nativeElement);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.checkForWarmStateLoginInput(changes)) {
      this.nextDisplayViewService.modalContainerFocus();
      return;
    }
    if (this.checkForDisplayLoginInput(changes)) {
      this.shouldcallservice = changes.displayLoginModal.currentValue
        ? 'true'
        : 'false';
      this.callServices(this.shouldcallservice);
      this.nextDisplayViewService.modalContainerFocus();
    }
  }

  toggleModal = () => {
    this.toggleModalHelper();
    const loginModalDiv = document.querySelector('.login-modal-container');
    if (
      (!loginModalDiv || !!loginModalDiv.classList.contains('d-none')) &&
      !this.loadSpinner
    ) {
      this.hideModal.emit();
      this.displayNextScreen(VIEW_NAME.LOGIN_CREDENTIALS_SCREEN);
      this.resetPasswordFacade.resetForm();
    }
  };

  ngAfterContentChecked(): void {
    this.checkLoadSpinnerClass();
    this.checkAlertAdvisorContainer();
    this.toggleBackdrop();
    this.checkInfoIconClicked();
  }

  checkLoadSpinnerClass() {
    this.loadSpinner = !!document.querySelector('.idp-loader__overlay');
  }

  checkAlertAdvisorContainer() {
    this.advisorBanner = !!document.querySelector(
      '.alert-advisory-main-container'
    );
  }

  checkInfoIconClicked() {
    this.infoIconClicked = !!document.querySelector(
      '.idp-error-tooltip__wrapper'
    );
  }

  toggleBackdrop() {
    this.toggleBackdropHelper();
  }

  callServices(makeBackendCall = 'false'): void {
    const makeCall = makeBackendCall === 'true' ? true : false;
    this.facade.redirectUrl = this.redirectUrl;
    this.facade.getPageContent(makeCall, this.fromApp);
    this.shouldcallservice = 'false';
  }

  logOutAndShop() {
    const elementTag = document.querySelector(
      'idp-login-modal-profile-selector'
    ) as HTMLElement;
    if (elementTag) {
      elementTag.setAttribute('logout', 'true');
    } else {
      this.logOut.emit();
    }

    this.analytics.dispatchCustomEvent(
      ANALYTICS_EVENTS_LOGIN.LOGOUT_SHOP_AGAIN,
      true
    );
  }
}
